<div class="dealcard mat-elevation-z4" *ngIf="!!deal" (click)="viewDeal(deal)">
    <div class="img-container" [style.background-image]="'url(' + deal.dealImageUrl + ')'">

    <div class="pills-container" *ngIf="deal.pills?.length">
      <div class="pill" *ngFor="let p of deal.pills"
           [title]="p.tooltip" 
           [ngStyle]="{'background-color': p.backgroundColor, 'color':p.fontColor, 'border-color': p.borderColor}"
      >{{p.name.toUpperCase()}}</div>
    </div>

    </div>
    <div class="text-container">
        <b>{{deal.projectName}}</b>
        <em class="muted-text asset-name">{{deal.assetName}}</em>
        <!-- <span class="text-description">{{deal.description}}</span> -->
         <span class="text-description">{{deal.oneLineTeaser}}</span>
    </div>
    <div class="metrics-container">
        <div class="metric" title="Total deal size in USD">
            <span class="metric-label">Size</span>
            <span class="metric-value">{{ dealSizeFormatted()}}</span>
        </div>
        <div class="metric" title="Target Multiple on Invested Capital (MOIC)">
            <span class="metric-label">MOIC</span>
            <span class="metric-value">{{deal.targetMoicBase}} x</span>
        </div>
         <div class="metric" title="Expected duration of the deal in years">
            <span class="metric-label">Duration</span>
            <span class="metric-value">{{deal.expectedDuration}} years</span>
        </div>
    </div>
    <div class="timeline-container">
        <app-timeline *ngIf="!!deal.dealTimeline && deal.dealCloseType == 'DRAWDOWN'"
                    [dealTimeline]="deal.dealTimeline"></app-timeline>
        
        <span class="evergreen" *ngIf="deal.dealCloseType == 'EVERGREEN'">EVERGREEN</span>
    </div>
    <!-- <div class="action-container" style="text-align: center;">
        <a class="full-width" mat-raised-button color="primary" *ngIf="isPreview == false" (click)="viewDeal(deal)">View Deal</a>
        <a class="full-width" mat-raised-button color="primary" *ngIf="isPreview == true" (click)="viewDeal(deal)">View Deal Preview</a>
    </div> -->
</div>